import { useEffect, useState } from "react";

import { HeroSectionDesktop } from "Components/organisms/Banner/Desktop";
import { HeroSectionMobile } from "Components/organisms/Banner/Mobile";
import { useBreakpoint } from "shared/hooks/useBreakpoint";

/**
 * Componente HeroTemplate
 *
 * Renderiza a seção de destaque (Hero Section) alternando entre as versões Desktop e Mobile
 * com base no tamanho da tela.
 */
export function HeroTemplate() {
  const [desktop, setDesktop] = useState(true);
  const breakpoint = useBreakpoint();

  useEffect(() => {
    setDesktop(
      breakpoint === "xxl" || breakpoint === "xl" || breakpoint === "lg",
    );
  }, [breakpoint]);

  return desktop ? <HeroSectionDesktop /> : <HeroSectionMobile />;
}
